export default __webpack_public_path__ + "static/media/money.5d042233.png";